// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--zCriI","title":"_02712f2b3b--title--tDi9B","text":"_02712f2b3b--text--BJO_p"};